import { useCallback } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service';
import { performGetRequest } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests.tsx';
import type { TicketType } from '@atlassian/jira-servicedesk-ticket-types-store/src/common/types.tsx';

type RequestTypesResponse = {
	ticketTypes: TicketType[];
	groups: string[];
	practices: string[];
};

const getRequestTypesUrl = (projectId: number, practice: string) =>
	`/rest/servicedesk/1/servicedesk/${projectId}/request-types?practices=${practice}`;

export const useRequestTypesForPracticeService = (projectId: number, practice: string) => {
	const url = getRequestTypesUrl(projectId, practice);

	const request = useCallback(
		() => performGetRequest(url).then((response: RequestTypesResponse) => response.ticketTypes),
		[url],
	);

	return useService<TicketType[]>(request);
};
